import { Box, Typography, Divider, Card } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import BackButton from '../../../components/Buttons/BackButton';
import SkeletonWrapper from '../../../components/Skeletons/SkeletonWrapper';
import FinalForm from '../../../components/TemplatesForms/FinalForm';
import { IMetadataJSON } from '../../../components/TemplatesForms/Selector/types';


interface ISpecificFromScratchApplicationProps {
  formTitle: string;
  form_stacture: IMetadataJSON[]
  form_checkBoxes: {
    acceptPolicy: boolean;
    truthOnDetails: boolean;
  },
  onSubmit: any,
  isLoading: boolean
}

function SpecificFromScratchApplication(props: ISpecificFromScratchApplicationProps) {
  const { form_stacture = [], form_checkBoxes = [] as any, formTitle = '', onSubmit } = props;
  const navigate = useNavigate();
  return (<>
    <Box mt={2} mb={4}>
      <BackButton onClick={() => navigate('/applications')}></BackButton>
    </Box>
    <Box>
      <SkeletonWrapper loading={props.isLoading} skeletonLines={10}>
        <Card style={{
          backgroundColor: '#ffffff',
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          padding: '16px',
          minWidth: 200
        }}>
          <Typography variant='h2' sx={{ display: 'flex', justifyContent: 'center' }}>
            {formTitle}
          </Typography>
          <Divider sx={{ m: 3 }} />
          <Box p={2}>
            <FinalForm
              form_checkBoxes={form_checkBoxes?.[0]}
              form_stacture={form_stacture}
              onSubmit={onSubmit}
            />
          </Box>
        </Card>
      </SkeletonWrapper>
    </Box >


  </>
  );
}

export default SpecificFromScratchApplication;